export const CAMPAIGN_MEASUREMENT = "CAMPAIGN_MEASUREMENT";

export type CampaignMeasurementAction = {
  type: typeof CAMPAIGN_MEASUREMENT;
};
